import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HomeCarousel from "../customer/Components/Carousel/HomeCarousel";
import { homeCarouselData } from "../customer/Components/Carousel/HomeCaroselData";
import HomeProductGrid from "../customer/Components/Home/HomeProductGrid";
import api from "../config/api";

const Homepage = () => {
    const { auth } = useSelector((store) => store);
    const [seasonalProducts, setSeasonalProducts] = useState([]);
    const [vegetableLeaves, setVegetableLeaves] = useState([]);
    const [bestSellers, setBestSellers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);

                // Fetch seasonal products (seasonal_produce category)
                const seasonalResponse = await api.get(
                    `/api/products?color=&size=&minPrice=0&maxPrice=100000&minDiscount=0&category=seasonal_produce&stock=null&sort=price_low&pageNumber=0&pageSize=20`
                );
                const allSeasonalData = seasonalResponse.data?.content || [];

                // Separate fruits from vegetable leaves
                const leafKeywords = ['gongura', 'moringa', 'munagaku'];
                const fruits = allSeasonalData.filter(
                    (p) => !leafKeywords.some((k) => p.title?.toLowerCase().includes(k))
                );
                const leaves = allSeasonalData.filter(
                    (p) => leafKeywords.some((k) => p.title?.toLowerCase().includes(k))
                );
                setSeasonalProducts(fruits);
                setVegetableLeaves(leaves);

                // Fetch best sellers from dedicated API (sorted by order count)
                try {
                    const bestSellersResponse = await api.get(`/api/products/best-sellers?limit=8`);
                    setBestSellers(bestSellersResponse.data || []);
                } catch {
                    // Fallback: if best-sellers endpoint fails, use seasonal products
                    setBestSellers(fruits.slice(0, 8));
                }

                setLoading(false);
            } catch (error) {
                console.error("Error fetching products:", error);
                setLoading(false);
            }
        };

        fetchProducts();
    }, [auth.user]); // Refetch products when auth state changes (after login)

    return (
        <div className="">
            <HomeCarousel images={homeCarouselData} />

            <div className="space-y-10 py-5 bg-white">
                <HomeProductGrid data={seasonalProducts} section={"What's In Season"} loading={loading} />
                {vegetableLeaves.length > 0 && (
                    <HomeProductGrid data={vegetableLeaves} section={"Vegetable Leaves"} loading={loading} />
                )}
                <HomeProductGrid data={bestSellers} section={"Best Sellers"} loading={loading} />
            </div>
        </div>
    );
};

export default Homepage;
